module.exports = __webpack_public_path__ + "img/figma-grey.101e4780.svg";